import { render, staticRenderFns } from "./VentaClienteMensual.vue?vue&type=template&id=225c347b&scoped=true&"
import script from "./VentaClienteMensual.vue?vue&type=script&lang=js&"
export * from "./VentaClienteMensual.vue?vue&type=script&lang=js&"
import style0 from "./VentaClienteMensual.vue?vue&type=style&index=0&id=225c347b&scoped=true&lang=css&"
import style1 from "./VentaClienteMensual.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225c347b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VRow,VSelect,VSimpleTable})
